import React, { useState, useContext, useEffect } from "react";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import StarIcon from "@mui/icons-material/Star";
import ImageSlider from "./BodyData/ImageSlider";
import { LikeCountContext } from "./BodyData/LikeNumbers";
import { CartCountContext } from "./BodyData/CartNumbers";
import productData from "./BodyData/ProductData";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import PriceContext from "./BodyData/PriceContext";

export let totalAmount = 0;

function Body() {
  const [heartColor, setHeartColor] = useState(null);
  const [cartColor, setCartColor] = useState(null);
  const [productList, setProductList] = useState(() => {
    const updatedProductData = {};

    productData.forEach((category) => {
      const { category: categoryName, items } = category;
      updatedProductData[categoryName] = {};

      items.forEach((item, itemIndex) => {
        updatedProductData[categoryName][`item${itemIndex + 1}`] = {
          ...item,
          isFavorite: false,
          cartCount: 0,
        };
      });
    });

    return updatedProductData;
  });

  const { likeCount, incrementLikeCount, decrementLikeCount } =
    useContext(LikeCountContext);
  const { cartCount, incrementCartCount } = useContext(CartCountContext);

  const [newPriceArray, setNewPriceArray] = useState([]);

  const handleFavoriteClick = (categoryKey, itemKey) => {
    setProductList((prevProductList) => {
      const updatedProductList = { ...prevProductList };
      const item = updatedProductList[categoryKey][itemKey];

      if (item.isFavorite) {
        decrementLikeCount();
      } else {
        incrementLikeCount();
      }

      item.isFavorite = !item.isFavorite;

      setTimeout(() => {
        setHeartColor("#008DFF");
      }, 150);

      return updatedProductList;
    });
  };

  const handleAddToCartClick = (categoryKey, itemKey) => {
    setProductList((prevProductList) => {
      const updatedProductList = { ...prevProductList };
      const item = updatedProductList[categoryKey][itemKey];

      incrementCartCount();
      item.cartCount++;

      setNewPriceArray((prevNewPriceArray) => {
        const updatedNewPriceArray = [
          ...prevNewPriceArray,
          item.price.newPrice,
        ];
        totalAmount = updatedNewPriceArray.reduce(
          (total, price) => total + price,
          0
        );
        console.log("Total Price:", totalAmount);
        return updatedNewPriceArray;
      });

      setTimeout(() => {
        setCartColor("#008DFF");
      }, 150);

      return updatedProductList;
    });
  };

  return (
    <PriceContext.Provider value={totalAmount}>
      <div className="h-full lg:w-11/12 mx-auto flex flex-col justify-between">
        <div>
          <h3 className="text-left text-2xl mt-6 mb-4 text-grayColor font-semibold">Chegirmalar</h3>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {Object.entries(productList).map(([categoryKey, category]) =>
            Object.entries(category).map(([itemKey, item]) => (
              <div
                key={`${categoryKey}-${itemKey}`}
                className="flex hover:cursor-pointer flex-col bg-white rounded-lg shadow-md p-3"
              >
                <div className="flex justify-between mb-2">
                  <div className="flex space-y-2 flex-col">
                    <button className="px-3 text-black font-semibold py-1 rounded-md bg-yellow-400 motion-bg-sale">
                      Chegirma
                    </button>
                    <button className="px-3 text-white font-semibold py-1 rounded-md bg-rose-500 motion-bg">
                      Yangi
                    </button>
                  </div>
                  <div className="flex space-y-4 flex-col">
                    <button
                      onClick={() => handleAddToCartClick(categoryKey, itemKey)}
                    >
                      {item.cartCount > 0 ? (
                        <ShoppingCartIcon
                          style={{
                            color: cartColor,
                          }}
                          fontSize="large"
                        />
                      ) : (
                        <AddShoppingCartIcon fontSize="large" />
                      )}
                    </button>
                    <div className="relative">
                      <button
                        onClick={() =>
                          handleFavoriteClick(categoryKey, itemKey)
                        }
                      >
                        {item.isFavorite ? (
                          <FavoriteIcon
                            style={{
                              color: heartColor,
                            }}
                            fontSize="large"
                          />
                        ) : (
                          <FavoriteBorderIcon fontSize="large" />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="w-full h-48 mx-auto relative overflow-hidden">
                  <div
                    className="image-container"
                    onDoubleClick={() =>
                      handleFavoriteClick(categoryKey, itemKey)
                    }
                  >
                    <ImageSlider images={item.images} />
                  </div>
                </div>
                <div className="text-base sm:text-lg font-semibold mt-2 mb-1">
                  {item.title}
                </div>
                <div className="flex items-center mb-2">
                  {Array.from({ length: 5 }, (_, index) => (
                    <React.Fragment key={index}>
                      {index < item.rating ? (
                        <StarIcon
                          fontSize="small"
                          className="text-yellow-400"
                        />
                      ) : (
                        <StarOutlineIcon
                          fontSize="small"
                          className="text-gray-400"
                        />
                      )}
                    </React.Fragment>
                  ))}
                  <div className="flex items-center ml-2 text-base text-gray-600">
                    <ChatBubbleOutlineIcon className="mr-1" />
                    <span>{item.comments} comments</span>
                  </div>
                </div>
                <div className="flex items-baseline mb-2">
                  <div className="text-gray-600 line-through text-sm sm:text-base">
                    ${item.price.oldPrice}
                  </div>
                  <div className="text-green-500 ml-2 text-base sm:text-lg">
                    ${item.price.newPrice}
                  </div>
                </div>
                {item.variantPrices.map((variant, index) => (
                  <div key={index} className="text-sm text-gray-500 mb-1">
                    {variant.price}$ / {variant.duration}
                  </div>
                ))}
                <div className="flex justify-between btn-effect-container">
                  <button
                    className="p-1 xxl:p-2 xl:p-1 sm:px-3 sm:py-2 sm:text-base md:text-sm xl:text-sm xxl:tex-xl hover-btn-blue rounded-md bg-blue-500 text-white font-medium"
                    onClick={() => handleAddToCartClick(categoryKey, itemKey)}
                  >
                    Add to Cart
                  </button>
                  <button className="sm:text-base p-1 sm:px-3 sm:py-2 xl:p-1 xxl:p-2 md:text-sm xl:text-sm xxl:tex-xl hover-btn-green text-white hover:text-white rounded-md bg-gray-200 font-medium">
                    Buy One Click
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </PriceContext.Provider>
  );
}

export default Body;
